export const statusCodes = {
  BAD_REQUEST:400,
  UNAUTHORIZIED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
};
